import React, {useMemo} from 'react'
import {Typography} from '@material-ui/core'
import AnxietyLevel1Icon from 'assets/img/ic_ppg_anxiety_01.png'
import AnxietyLevel2Icon from 'assets/img/ic_ppg_anxiety_02.png'
import AnxietyLevel3Icon from 'assets/img/ic_ppg_anxiety_03.png'
import DepressionLevel1Icon from 'assets/img/ic_ppg_depression_01.png'
import DepressionLevel2Icon from 'assets/img/ic_ppg_depression_02.png'
import DepressionLevel3Icon from 'assets/img/ic_ppg_depression_03.png'
import SummaryTable from 'components/molcules/ProfitSummaryReport/SummaryTable'
import ReportSubtitle from 'components/Text/ReportSubtitle'
import useLanguage from 'features/languageReport/useLanguage'
import useStyles from 'components/molcules/N1SummaryReport/useStyles'

interface ItemCell {
  id: string
  label: string
}

const DepressionIconList = [
  DepressionLevel1Icon,
  DepressionLevel2Icon,
  DepressionLevel3Icon,
]

const AnxietyIconList = [
  AnxietyLevel1Icon,
  AnxietyLevel2Icon,
  AnxietyLevel3Icon,
]

export default function HRVSummarySentimental(props: {
  anxiety: number
  depression: number
  customerFirstName: string
  customerLastName: string
}) {
  const {anxiety, depression, customerFirstName, customerLastName} = props
  const classes = useStyles()
  const {textHrvAPI} = useLanguage('hrv')
  const englishCustomerName = `${customerFirstName} ${customerLastName}`

  const depressItems: ItemCell[] = useMemo(() => {
    return (
      textHrvAPI?.emotion_analysis.section.emotion_table.sadness.rows.map(
        (item) => ({
          id: item.phase,
          label: item.explanation,
        }),
      ) || []
    )
  }, [textHrvAPI])

  const anxietyItem: ItemCell[] = useMemo(() => {
    return (
      textHrvAPI?.emotion_analysis.section.emotion_table.tension.rows.map(
        (item) => ({
          id: item.phase,
          label: item.explanation,
        }),
      ) || []
    )
  }, [textHrvAPI])

  return (
    <div className={classes.hrvSentimental}>
      <Typography className={classes.padding} />
      <Typography className={classes.padding} />
      <Typography className={classes.padding} />
      <ReportSubtitle number='5'>
        {textHrvAPI?.emotion_analysis.title || ''}
      </ReportSubtitle>
      <br />

      <div className='Status notranslate'>
        <div className='StatusIcon'>
          <img
            className='StatusIcon-image'
            src={DepressionIconList[depression - 1]}
            alt='Depression status icon'
          />
          <div className='StatusIcon-label Depress'>
            {/* {t('IDepressLevel', {context: depression})} */}
            {
              textHrvAPI?.emotion_analysis.section.analysis_results.sadness
                .diagnosis.phases[
                `stage${depression}` as keyof typeof textHrvAPI.emotion_analysis.section.analysis_results.sadness.diagnosis.phases
              ]
            }
          </div>
        </div>
        <div className='Status-text'>
          <div className='Title'>
            {/* {i18n.language === 'ko'
              ? t('IDepressTitle', {
                  name: koreanCustomerName,
                  depress: t('IDepressLevel', {context: depression}),
                })
              : t('IDepressTitle', {
                  name: englishCustomerName,
                  depress: t('IDepressLevel', {context: depression}),
                })} */}
            {textHrvAPI?.emotion_analysis.section.analysis_results.sadness.diagnosis.main
              .replace('{0}', englishCustomerName)
              .replace(
                '{1}',
                textHrvAPI?.emotion_analysis.section.analysis_results.sadness
                  .diagnosis.phases[
                  `stage${depression}` as keyof typeof textHrvAPI.emotion_analysis.section.analysis_results.sadness.diagnosis.phases
                ],
              )}
          </div>
          <div className='Level'>
            {/* {t(getDescription(depression, 'depression'))} */}
            {
              textHrvAPI?.emotion_analysis.section.emotion_table.sadness.rows[
                depression - 1
              ].explanation
            }
          </div>
          <div className='Reference'>
            {
              textHrvAPI?.emotion_analysis.section.analysis_results.sadness
                .diagnosis.sub
            }
          </div>
        </div>
        <div className='StatusIcon'>
          <img
            className='StatusIcon-image'
            src={AnxietyIconList[anxiety - 1]}
            alt='Anxiety status icon'
          />
          <div className='StatusIcon-label Anxiety'>
            {/* {t('IAnxietyLevel', {context: anxiety})} */}
            {
              textHrvAPI?.emotion_analysis.section.analysis_results.tension
                .diagnosis.phases[
                `stage${anxiety}` as keyof typeof textHrvAPI.emotion_analysis.section.analysis_results.tension.diagnosis.phases
              ]
            }
          </div>
        </div>

        <div className='Status-text'>
          <div className='Title'>
            {/* {i18n.language === 'ko'
              ? t('IAnxietyTitle', {
                  name: koreanCustomerName,
                  anxiety: t('IAnxietyLevel', {context: anxiety}),
                })
              : t('IAnxietyTitle', {
                  name: englishCustomerName,
                  anxiety: t('IAnxietyLevel', {context: anxiety}),
                })} */}
            {textHrvAPI?.emotion_analysis.section.analysis_results.tension.diagnosis.main
              .replace('{0}', englishCustomerName)
              .replace(
                '{1}',
                textHrvAPI?.emotion_analysis.section.analysis_results.tension
                  .diagnosis.phases[
                  `stage${anxiety}` as keyof typeof textHrvAPI.emotion_analysis.section.analysis_results.tension.diagnosis.phases
                ],
              )}
          </div>
          <div className='Level'>
            {
              textHrvAPI?.emotion_analysis.section.emotion_table.tension.rows[
                anxiety - 1
              ].explanation
            }
          </div>
          <div className='Reference'>
            {
              textHrvAPI?.emotion_analysis.section.analysis_results.tension
                .diagnosis.sub
            }
          </div>
        </div>
      </div>
      <Typography className={classes.padding} />
      <div className='TableTitle'>
        {textHrvAPI?.emotion_analysis.section.emotion_table.sadness.title}
      </div>
      <SummaryTable
        items={depressItems}
        headerTitle={
          textHrvAPI?.emotion_analysis.section.emotion_table.sadness
            .headers[0] || ''
        }
        descriptionTitle={
          textHrvAPI?.emotion_analysis.section.emotion_table.sadness
            .headers[1] || ''
        }
      />
      <Typography className={classes.padding} />
      <div className='TableTitle'>
        {textHrvAPI?.emotion_analysis.section.emotion_table.tension.title}
      </div>
      <SummaryTable
        items={anxietyItem}
        headerTitle={
          textHrvAPI?.emotion_analysis.section.emotion_table.tension
            .headers[0] || ''
        }
        descriptionTitle={
          textHrvAPI?.emotion_analysis.section.emotion_table.tension
            .headers[1] || ''
        }
      />
    </div>
  )
}
